
export const validationPatterns = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  phone: /^\+?[\d\s-]{10,}$/,
  username: /^[a-zA-Z0-0_]{3,20}$/,
  password: /^.{6,}$/,
  url: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
};

export const validateField = (name, value, rules = {}) => {
  if (rules.required && (!value || (typeof value === 'string' && !value.trim()))) {
    return `${rules.label || name} is required`;
  }

  if (value) {
    if (rules.type === 'email' && !validationPatterns.email.test(value)) {
      return 'Please enter a valid email address';
    }
    if (rules.type === 'phone' && !validationPatterns.phone.test(value)) {
      return 'Please enter a valid phone number';
    }
    if (rules.type === 'url' && !validationPatterns.url.test(value)) {
      return 'Please enter a valid URL';
    }
    if (rules.minLength && value.length < rules.minLength) {
      return `${rules.label || name} must be at least ${rules.minLength} characters`;
    }
    if (rules.maxLength && value.length > rules.maxLength) {
      return `${rules.label || name} must not exceed ${rules.maxLength} characters`;
    }
    if (rules.pattern && !rules.pattern.test(value)) {
      return rules.patternMessage || `Invalid ${rules.label || name} format`;
    }
  }

  return null;
};

export const validateForm = (formData, formRules) => {
  const errors = {};
  Object.keys(formRules).forEach(field => {
    const error = validateField(field, formData[field], formRules[field]);
    if (error) {
      errors[field] = error;
    }
  });
  return errors;
};
